import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import PageHero from "../ones/PageHero";
import Footer from "../ones/Footer";
import { industries, industryOverview } from "../data/siteContent";
import CallToAction from "../ones/callToAction";

export default function IndustryLanding() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <PageHero
        title={industryOverview.title}
        description={industryOverview.intro}
        badge="Our Industry"
      />

      <section className="ags-section">
        <div className="container">
          <div className="row g-4">
            {industries.map((industry, index) => (
              <div
                className="col-md-6 col-xl-3"
                key={industry.title}
                data-aos="fade-up"
                data-aos-delay={index * 45}
              >
                <div
                  className={`ags-industry-card ${industry.visual} h-100`}
                  style={{ backgroundImage: `url(${industry.image})` }}
                >
                  <div className="ags-industry-card-inner">
                    <span className="ags-service-chip">{industry.stat}</span>
                    <h4 className="font-bold text-white mt-3 mb-3">
                      {industry.title}
                    </h4>
                    <p className="text-white-50 mNoMargin">{industry.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <CallToAction />

      <Footer />
    </>
  );
}
